import { render, staticRenderFns } from "./ServiceDialog.vue?vue&type=template&id=b6ece0e8&scoped=true"
import script from "./ServiceDialog.vue?vue&type=script&lang=js"
export * from "./ServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./ServiceDialog.vue?vue&type=style&index=0&id=b6ece0e8&prod&lang=css"
import style1 from "./ServiceDialog.vue?vue&type=style&index=1&id=b6ece0e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ece0e8",
  null
  
)

export default component.exports